import axios from 'axios';
import config  from '../../env.json';

export const getAllAppAdminPermissions = async (domainURL: any) => {
  try {
    const response = await axios.get(config.REACT_APP_SYSTEM_ADMIN_API + "/permission/tenant/getallAppAdminPermission?domain=" + domainURL);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    return { error: 'Failed to fetch permissions' }
  }
};


export const UpdateAllAppAdminPermissions = async (data: any, domainURL: any) => {
  try {
    const response = await axios.post(config.REACT_APP_SYSTEM_ADMIN_API + "/permission/tenant/updateAppAdminPermission?domain=" + domainURL, data);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    return { error: 'Failed to update permissions' }
  }
}

export const getAllAppAdminChildPermissions = async (permissionId: any, domainURL: any) => {
  try {
    const response = await axios.get(config.REACT_APP_SYSTEM_ADMIN_API + "/permission/tenant/getallAppAdminChildPermission?domain=" + domainURL, {
      params: {
        Permission_Id: permissionId,
      },
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    return { error: 'Failed to fetch child permissions' };
  }
};